module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "swiper-wrap",
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_c('div', {
    staticClass: "slider-wrap"
  }, [_c('div', {
    staticClass: "slider-container"
  }, [_c('div', {
    staticClass: "item slide tns-item"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/02_2x.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item slide tns-item"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/03_2x.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item slide tns-item"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/04_2x.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item slide tns-item"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/05_2x.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item slide tns-item"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/06_2x.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item slide tns-item"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/slider-fabbrica.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item slide tns-item"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/slider-lab.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "slider-arrows-wrap"
  }, [_c('div', {
    staticClass: "prev slider-arrow"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/arrow-slide-prev@2x.png"),
      "data-over": "cta"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next slider-arrow"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/arrow-slide-next@2x.png"),
      "data-over": "cta"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74de31da","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SliderCarousel.vue
// module id = 331
// module chunks = 0